var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bar-main" }, [
    _c(
      "div",
      { staticStyle: { width: "20px" } },
      [
        _c("el-checkbox", {
          on: { change: _vm.onChange },
          model: {
            value: _vm.element.mobileSelected,
            callback: function ($$v) {
              _vm.$set(_vm.element, "mobileSelected", $$v)
            },
            expression: "element.mobileSelected",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }